import api from './client'

/**
 * Experiencias de la tienda web — cenas, eventos y viajes.
 *
 * El alta crea de una el artículo (EVT…) con su precio de lista y el contenido
 * con el que se publica: el evento nace en LGR y no en Magento. Presea le pone
 * su código después; hasta entonces el artículo figura "Pendiente".
 */
export const experienciasApi = {
  listar: () => api.get('/web/experiencias'),
  ver: (id) => api.get(`/web/experiencias/${id}`),
  crear: (datos) => api.post('/web/experiencias', datos),
  actualizar: (id, datos) => api.put(`/web/experiencias/${id}`, datos),
  duplicar: (id, titulo) => api.post(`/web/experiencias/${id}/duplicar`, { titulo }),
  /** Archivar guarda sin borrar: sale de la web y del listado por defecto. */
  // Mail a quien opera Presea con toda la data para dar de alta el artículo.
  avisoAlta: (id) => api.post(`/web/experiencias/${id}/aviso-alta`),
  archivar: (id) => api.post(`/web/experiencias/${id}/archivar`),
  /** Google Ads: el OK para pautarla con la config GUARDADA (y retirarlo). */
  aprobarAds: (id) => api.post(`/web/experiencias/${id}/ads/aprobar`),
  desaprobarAds: (id) => api.post(`/web/experiencias/${id}/ads/desaprobar`),
  desarchivar: (id) => api.post(`/web/experiencias/${id}/desarchivar`),
  /** Pega el texto del evento y vuelve repartido en los bloques del form. */
  interpretar: (texto) => api.post('/web/experiencias/interpretar', { texto }),
  eliminar: (id) => api.delete(`/web/experiencias/${id}`),
  /** Historia de Instagram (a · b · c) en JPG, como blob para mostrar y descargar. */
  historia: (id, variante) => api.get(`/web/experiencias/${id}/historias/${variante}`, { responseType: 'blob' }),
  /** Menú impreso de la cena: lo guardado (o la propuesta desde el evento), guardar y el PDF. */
  menu: (id, propuesta = false) => api.get(`/web/experiencias/${id}/menu`, { params: propuesta ? { propuesta: 1 } : {} }),
  guardarMenu: (id, menu) => api.put(`/web/experiencias/${id}/menu`, { menu }),
  /** Ortografía de todo lo que se imprime (hunspell es_AR en el servidor). */
  revisarMenu: (id, menu) => api.post(`/web/experiencias/${id}/menu/revisar`, { menu }),
  pdfMenu: (id, menu, formato) => api.post(`/web/experiencias/${id}/menu/pdf`, { menu, formato }, { responseType: 'blob' }),
  /** Los artículos elegidos como renglones del menú (marca, nombre y añada del maestro). */
  menuVinos: (articuloIds) => api.post('/web/experiencias-menu/vinos', { articulo_ids: articuloIds }),
  subirFoto: (file) => {
    const fd = new FormData()
    fd.append('imagen', file)
    // multipart explícito (como los otros uploads): ver client.js.
    return api.post('/web/experiencias/foto', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  guardarTipo: (datos) => api.post('/web/experiencias/tipos', datos),
  // Invitaciones: la tarjeta (nace con el alta) y la lista de quienes compraron.
  invitados: (id) => api.get(`/web/experiencias/${id}/invitados`),
  linksInvitados: (id) => api.get(`/web/experiencias/${id}/invitados/links`),
  guardarTarjeta: (id, datos) => api.put(`/web/experiencias/${id}/invitacion`, datos),
  /** La tarjeta como quedaría con estos valores, sin guardar (vista previa del panel). */
  vistaPreviaTarjeta: (id, datos) => api.post(`/web/experiencias/${id}/invitacion/vista-previa`, datos),
}
